// @owners { team: patients }
import { SIZES, SPACING } from '@alto/design-library-tokens';
import { Button, Card, Column, Description, LgPadding, MdSpacing } from '@alto/design-system';
import React from 'react';
import { Linking } from 'react-native';
import styled from 'styled-components/native';
import { getImage } from '~shared/assets/images/getImage';
import { IMG_ALT_TEXTS, getProgynyUnboxingGuideUrl } from '~shared/constants';
import { useAnalytics, usePageViewedEvent } from '~shared/hooks';
import { EVENTS } from '~shared/lib/analytics/src/constants';

// FullPage order-success (web) has no content max-width, so the card would otherwise
// stretch edge-to-edge. Cap at the same width SecondaryPage uses on desktop; width 100%
// keeps it filling the padded column on mobile.
const CardContainer = styled(Column)`
  width: 100%;
  max-width: ${SIZES.PAGE.CONTENT_WIDTH.LG};
  align-self: center;
`;

export const ProgynyUnboxingGuide = () => {
  const { trackEvent } = useAnalytics();

  const onPressUnboxingGuide = () => {
    trackEvent({ event: EVENTS.UNBOXING_GUIDE_TAPPED });
    Linking.openURL(getProgynyUnboxingGuideUrl());
  };

  usePageViewedEvent({
    event: EVENTS.ALTO_EDU_UNBOXING_GUIDE_VIEWED,
  });

  return (
    <CardContainer testID="progyny-unboxing-guide">
      <Card
        title="Prepare for your upcoming order"
        illustrationSrc={getImage('fertilityPackageDelivered')}
        illustrationAccessibilityLabel={IMG_ALT_TEXTS.fertilityPackageCheckmark}
      >
        <LgPadding topPadding={SPACING.STATIC.MD}>
          <Description>See helpful information, including unboxing and storage guidance</Description>
          <MdSpacing />
          <Button
            width="inline"
            type="primary"
            label="See unboxing guide"
            onPress={onPressUnboxingGuide}
          />
        </LgPadding>
      </Card>
    </CardContainer>
  );
};
